
































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class CommodityView extends Vue {
  public items: Common.Commodity[] = new Array(0);
  public params: Common.CommodityQuery = new Common.CommodityQuery();
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true, true, true, true, true, true];
  public importQuery = new Common.CommodityImportQuery('商品');
  public exportQuery = new Common.CommodityExportQuery('商品',this.params);
  public tenantSettings: Common.TenantSettings = new Common.TenantSettings();
  public hasLicenseTrade: boolean = false;
  public visibleTypes = Common.visibleTypes;  
  public voucherTypes = Common.voucherTypes; //voucherTypesのエイリアス
  public ecFlags = Common.ECFlags;
  @Prop() public auditNo:string;
  @Prop({default:null}) public popup: Components.PopupEditor;  
   
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'code', text: 'コード' },
    { value: 'name', text: '名称' },
    { value: 'manufacturer', text: 'メーカー' },
    { value: 'model', text: '型番' },
    { value: 'name2', text: '名称2' },
    { value: 'name3', text: '名称3' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];

  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],3, 'grid');
  public disabled(item : Common.Commodity) {
    return item == null || item.state != Common.MasterBaseStatus.Posted;
  }


  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;    
    
    // ライセンスによって表示項目を制御する
    this.hasLicenseTrade = this.$api.hasLicense(Common.licenseFlags.import) || this.$api.hasLicense(Common.licenseFlags.export);

    // 利用する機能によって表示項目を制御する
    this.$set(this.tabVisibles, 2, this.$api.useOperationFunction);
    this.$set(this.tabVisibles, 3, this.$api.useStockFunction);
    this.$set(this.tabVisibles, 4, this.$api.useStockFunction);
    this.$set(this.tabVisibles, 5, this.$api.useStockFunction);
    this.$set(this.tabVisibles, 7, this.$api.useStockFunction);

    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 100),
      new Common.GridItemConfiguration('ワークフロー', 180),      
      new Common.GridItemConfiguration('コード', 150),
      new Common.GridItemConfiguration('名称', 200),
       new Common.GridItemConfiguration('計上単位', 150),
      new Common.GridItemConfiguration('棚卸商品区分', 150),
      new Common.GridItemConfiguration('型番', 150),
      new Common.GridItemConfiguration('メーカー', 150),
      new Common.GridItemConfiguration('名称2', 200,this.hasLicenseTrade),
      new Common.GridItemConfiguration('名称3', 200,this.hasLicenseTrade),  
      new Common.GridItemConfiguration('Net(kg)', 150,this.hasLicenseTrade),
      new Common.GridItemConfiguration('Gross(kg)', 150,this.hasLicenseTrade),
      new Common.GridItemConfiguration('Volume(m3)', 150,this.hasLicenseTrade),
      new Common.GridItemConfiguration('category_11', 150),
      new Common.GridItemConfiguration('category_12', 150),
      new Common.GridItemConfiguration('category_13', 150),
      new Common.GridItemConfiguration('category_14', 150),
      new Common.GridItemConfiguration('category_15', 150),
      new Common.GridItemConfiguration('category_16', 150),
      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者 ', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150)
    );

    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;
    this.importQuery.hasLicenseTrade = this.hasLicenseTrade;
    this.exportQuery.hasLicenseTrade = this.hasLicenseTrade;

    // 検索条件を設定する
    if(this.auditNo) {
      this.params.auditNo = this.auditNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    this.$api.formatter.ensureListLoaded('workflow_masterBase');        
  }

  public async onCreate(obj: Common.Commodity) {
    if(this.params != null && this.params.isNoStock != null) obj.isNoStock = this.params.isNoStock;
    const workflows = this.$api.formatter.getOptions('workflow_masterBase');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public workflowRequired(item: Common.Commodity):boolean {
    if(item.state != Common.MasterBaseStatus.NotPosted) return false;
    var workflows = this.$api.formatter.getOptions('workflow_masterBase');
    return workflows.length > 0;
  }

  public isEditable(item: Common.Commodity):boolean {
    return item.state == Common.MasterBaseStatus.NotPosted;
  }

  // 上代単価を0許容に
  // public sellingPriceRequired(item: Common.Commodity):boolean {
  //   return item.priceType == Common.SalesPricingTypes.PricingRate;
  // }

  // 一覧選択時に明細表示ボタンを非活化状態更新

  disableShowConversion :boolean = false;
  disableShowSku :boolean = false;  
  disableShowPrice :boolean = false;    
  disableShowShelfNo:boolean = false;
  public onSelectedMain(index: number, selected: Common.Commodity) {

      this.disableShowConversion = selected.state != Common.MasterBaseStatus.Posted;
      this.disableShowSku = selected.state != Common.MasterBaseStatus.Posted;
      this.disableShowPrice = selected.state != Common.MasterBaseStatus.Posted;            
      this.disableShowShelfNo = selected.state != Common.MasterBaseStatus.Posted;
    
    // 補充単位はコードしか持たないため、クライアント側で選択時に取得
    if(selected.replenishmentUomCode != null && selected.replenishmentUomCode != selected.uom) {
      var query = new Common.ConversionQuery();
      query.commodityCode = selected.code;
      query.code = selected.replenishmentUomCode;
      this.$api.execute(query).then(res => {
        var items = (res as Common.LoadResult).result;
        if(items!=null)selected.replenishmentUom = items[0];
        else selected.replenishmentUom = selected.getDefaultConversion();
      });
    }
    else{
      selected.replenishmentUom = selected.getDefaultConversion();
    }

    //変更履歴のロードなどあると若干タイムラグが発生する
    // var query = new Common.CommodityChildItemQuery(selected);
    // this.$api.execute(query).then(res => {
    //   var result = res as Common.CommodityChildItemResult;
    //   this.disableShowConversion = result.hasConversionItems == false;
    //   this.disableShowSku = result.hasSkuItems == false;
    //   this.disableShowPrice = result.hasPriceItems == false;            
    //   this.disableShowShelfNo = result.hasShelfNoItems == false;
    // });
  }

  //明細表示ボタンクリック時に画面遷移
  public showChildItems(item: Common.Commodity, flag:string)
  {
      if (flag == 'conversion')
        this.$router.push(String.format('/master/Conversion?commodityCode={0}', item.code));      
      else if (flag == 'sku')
        this.$router.push(String.format('/master/SKU?commodityCode={0}', item.code));
      else if (flag == 'price')
        this.$router.push(String.format('/master/Price?commodityCode={0}', item.code));      
      else if (flag == 'shelfNo')
        this.$router.push(String.format('/master/ShelfNo?commodityCode={0}', item.code));            
  }

  public isRequiredBarcode(barcodeType: Common.BarcodeTypes){
    return barcodeType > 0;
  }  
}

